import { createTheme } from "@material-ui/core/styles";
import { ptBR } from "@material-ui/core/locale";

const light = createTheme(
  {
    palette: {
      primary: {
        main: "#FFF",
        text: "#000",
      },
      secondary: {
        main: "#ffa21a",
        hover: "#008000",
      },
      error: {
        main: "#ff0000",
      },
      success: {
        main: "#008000",
      },
      white: {
        main: "#FFF",
      },
      gray: {
        100: "#f6f9fc",
        200: "#e9ecef",
        300: "#dee2e6",
        400: "#ced4da",
        500: "#adb5bd",
        600: "#8898aa",
        700: "#525f7f",
        800: "#32325d",
        900: "#212529",
      },
    },
    props: {
      MuiButton: {
        variant: "outlined",
        size: "medium",
      },
      MuiRadio: {
        color: "#ffa21a"
      },
      MuiTextField: {
        color: "secondary",
        variant: "outlined",
        size: "small",
        fullWidth: true,
        autoComplete: "off",
      },
      MuiSelect: {
        color: "secondary",
        variant: "outlined",
        size: "small",
        fullWidth: true,
        autoComplete: "off",
      },
    },
  },
  ptBR
);
export default light;